/**
 * Convert a string to Title Case (first letter of each word capitalized)
 * Handles both space-separated and hyphen-separated words
 * @param str - The string to convert
 * @returns The string in Title Case
 * @example
 * toTitleCase("hello world") // "Hello World"
 * toTitleCase("NEW YORK CITY") // "New York City"
 * toTitleCase("dallas-fort worth") // "Dallas-Fort Worth"
 */
export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) =>
      word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-"),
    )
    .join(" ");
}

/**
 * Check whether a string parses to a finite, non-zero number.
 * @param str - The string to check
 * @returns True if the string parses to a finite, non-zero number
 * @example
 * isNonZeroNumberString("1.5") // true
 * isNonZeroNumberString("0") // false
 * isNonZeroNumberString("") // false
 * isNonZeroNumberString("abc") // false
 */
export function isNonZeroNumberString(str: string): boolean {
  if (str.trim() === "") return false;
  const n = Number(str);
  return Number.isFinite(n) && n !== 0;
}
